import { Link } from "react-router-dom";
import Text from "@/base/Text";
import Header from "@/base/Header";
import Form from "@/base/Form";
import FormInput from "@/base/FormInput";
import FieldError from "@/base/FieldError";
import {US_STATES} from "@util/constants.js";
import {useState} from "react";
import {css} from "@emotion/react";
import { rem } from "@util/convertUnits";

const RequestServiceForm = () => {

    const [, setFormData] = useState({})
    const [formIsComplete, setFormIsComplete] = useState(false);


    const commentCss = css(`
        textarea {
            height:10em;
        } 
    `);

    const containerCss = css(`
        width: 100%;
        max-width: ${rem(800)};
        margin-left: auto;
        margin-right: auto;
    `);

    const formCss = css(`
        width: 100%;
        max-width: ${rem(520)};
        margin-left: auto;
        margin-right: auto;
    `);

    const smWrap = css(`
        max-width: 39.8rem;
        margin-left: auto;
        margin-right: auto;
    `);

    if (formIsComplete) {
        return (
            <div>
                <Header tag="h3">Thank You</Header>
                <Text>
                    We would like to take this opportunity to thank you for your business. 
                    Our goal is to provide a service experience that exceeds your expectations.
                </Text>
                <Text>
                    Your service inquiry has been received and the details of your request are being reviewed. 
                    You will be contacted by a LaCantina Doors Customer Service Representative by the end of the next business day.
                </Text>
                <Text>For immediate assistance please feel free to contact the LaCantina Doors&rsquo; Customer Service department directly using the <a href="mailto:csr@lacantinadoors.com ">csr@lacantinadoors.com</a> or call (888) 221-0141.</Text>
                <Text>
                    Sincerely,<br/>
                    <br/>
                    <strong>LaCantina Doors</strong>
                </Text>
            </div>
        );
    }

    return (
        <>
            <div className="mb-5" css={containerCss}>
            <Text>
                LaCantina Doors has comprehensive technical, installation adjustment,
                and troubleshooting resources readily available: See our{" "}
                <Link to="/support/installation">Installation</Link> resources and{" "}
                <Link to="/support/technical-documents">Technical Documents</Link>. We
                encourage customers to refer to these resources prior to contacting us
                or your LaCantina Doors Dealer. Services outside of LaCantina
                Doors&apos; warranty will be subject to a service fee.
            </Text>
            <Text>
                Most issues encountered can be resolved quickly. And most dealers and
                distributors of LaCantina Products have factory-trained Certified
                Installers and service technicians who can provide onsite suport.
                LaCantina also has factory-trained Independent Certified Installers
                and technicians in various areas to support your service needs.
            </Text>
            <Text>
                For those issues that cannot be resolved easily and require additional
                assistance, please complete the Customer Service Request Form and fax
                to the dealer where you purchased your LaCantina product or submit to
                LaCantina Doors.
            </Text>
        </div>
            <div css={formCss}>
                <Form name="lac_request_service" onChange={setFormData} onSuccess={() => setFormIsComplete(true)}>
                    <div className="mb-3">
                        <FormInput
                            type="text"
                            label="First Name"
                            required={true}
                            name="first_name"
                            builtinError={true}
                        />
                        <FormInput
                            type="text"
                            label="Last Name"
                            required={true}
                            name="last_name"
                            builtinError={true}
                        />
                        <FormInput
                            type="text"
                            label="LaCantina Doors Order #"
                            name="order_number"
                            builtinError={true}
                        />
                        <FormInput
                            type="email"
                            label="Email"
                            required={true}
                            name="email"
                            builtinError={true}
                        />
                        <FormInput
                            type="phone"
                            label="Phone"
                            required={true}
                            name="phone"
                            builtinError={true}
                        />
                        <FormInput type="phone" label="Fax" required={false} name="fax" builtinError={true}/>
                        <FormInput
                            type="select"
                            label="Country"
                            required={true}
                            name="country"
                            builtinError={true}
                        >
                            <option value="">Select an Option</option>
                            <option value="usa">United States of America</option>
                            <option value="canada">Canada</option>
                        </FormInput>
                        <FormInput
                            type="text"
                            label="Address"
                            required={true}
                            name="address"
                            builtinError={true}
                        />

                        <div css={{display: "flex"}}>
                            <span css={{width: "60%", flexGrow: 1, marginRight: "0.25em"}}>
                            <FormInput
                                type="text"
                                label="City"
                                required={true}
                                builtinError={true}
                                name="city"
                            />
                            </span>
                            <span css={{flexGrow: 1}}>
                            <FormInput
                                type="select"
                                label="State"
                                required={true}
                                builtinError={true}
                                name="state"
                            >
                            {[{abbrev: "", name: "---"}, ...US_STATES].map((state) => (
                                <option key={state.abbrev} value={state.abbrev}>
                                    {state.abbrev}
                                </option>
                            ))}
                            </FormInput>
                            </span>
                        </div>

                        <FormInput
                            type="text"
                            label="Zip code"
                            required={true}
                            name="zip"
                            builtinError={true}
                        />
                    </div>

                    <div className="mb-3" css={smWrap}>
                        <Header tag="h4" tagStyle="h5">I am requesting service as...*</Header>
                        <FieldError name={`request_as`}/>
                        <div className="row">
                            <div className="size-full size-xs-1of2">
                                <FormInput
                                    type="checkbox"
                                    label="an Architect"
                                    name="request_as"
                                    value="architect"
                                />
                            </div>
                            <div className="size-full size-xs-1of2">
                                <FormInput
                                    type="checkbox"
                                    label="a Contractor"
                                    name="request_as"
                                    value="contractor"
                                />
                            </div>
                            <div className="size-full size-xs-1of2">
                                <FormInput
                                    type="checkbox"
                                    label="a Dealer"
                                    name="request_as"
                                    value="dealer"
                                />
                            </div>
                            <div className="size-full size-xs-1of2">
                                <FormInput
                                    type="checkbox"
                                    label="a Developer"
                                    name="request_as"
                                    value="developer"
                                />
                            </div>
                            <div className="size-full size-xs-1of2">
                                <FormInput
                                    type="checkbox"
                                    label="a Homeowner"
                                    name="request_as"
                                    value="homeowner"
                                />
                            </div>
                            <div className="size-full size-xs-1of2">
                                <FormInput
                                    type="checkbox"
                                    label="an Installer"
                                    name="request_as"
                                    value="installer"
                                />
                            </div>
                        </div>
                    </div>

                    <div className="mb-3">
                        <Header tag="h4" tagStyle="h5">Contractor/Installer/Dealer Name</Header>
                        <FormInput
                            type="text"
                            label="First Name"
                            required={true}
                            name="dealer_first_name"
                            builtinError={true}
                        />
                        <FormInput
                            type="text"
                            label="Last Name"
                            required={true}
                            name="dealer_last_name"
                            builtinError={true}
                        />
                    </div>

                    <div className="mb-3" css={smWrap}>
                        <Header tag="h4" tagStyle="h5">Contractor/Installer/Dealer Title*</Header>
                        <Text>I am requesting service as...</Text>
                        <FieldError name={`dealer_request_as`}/>
                        <div className="row">
                            <div className="size-full size-xs-1of2">
                                <FormInput
                                    type="checkbox"
                                    label="Contractor"
                                    name="dealer_request_as"
                                    value="contractor"
                                />
                            </div>
                            <div className="size-full size-xs-1of2">
                                <FormInput
                                    type="checkbox"
                                    label="Installer"
                                    name="dealer_request_as"
                                    value="installer"
                                />
                            </div>
                            <div className="size-full size-xs-1of2">
                                <FormInput
                                    type="checkbox"
                                    label="Dealer"
                                    name="dealer_request_as"
                                    value="dealer"
                                />
                            </div>
                            <div className="size-full size-xs-1of2">
                                <FormInput
                                    type="checkbox"
                                    label="Other"
                                    name="dealer_request_as"
                                    value="other"
                                />
                            </div>
                        </div>
                    </div>

                    <div className="mb-3" css={smWrap}>
                        <Header tag="h4" tagStyle="h5">Are the doors already installed?*</Header>
                        <FieldError name={`installed`}/>
                        <div className="row">
                            <div className="size-full size-xs-1of2">
                                <FormInput
                                    type="radio"
                                    label="Yes"
                                    required={false}
                                    name="installed"
                                    value="yes"
                                />
                            </div>
                            <div className="size-full size-xs-1of2">
                                <FormInput
                                    type="radio"
                                    label="No"
                                    required={false}
                                    name="installed"
                                    value="no"
                                />
                            </div>
                        </div>
                    </div>

                    <div className="mb-3">
                        <div css={commentCss}>
                            <FormInput
                                type="textarea"
                                name="message"
                                label="Describe the problem/issue requiring service"
                                required={true}
                                builtinError={true}
                            />
                        </div>
                    </div>

                    <div className="mb-5">
                        <Header tag="h4" tagStyle="h5">
                            Attach Photos (up to 3 image files allowed)
                        </Header>
                        <FormInput
                            type="file"
                            name="photo_0"
                            label="Attach Files"
                            required={false}
                            builtinError={true}
                        />
                        <FormInput
                            type="file"
                            name="photo_1"
                            label="Attach Files"
                            required={false}
                            builtinError={true}
                        />
                        <FormInput
                            type="file"
                            name="photo_2"
                            label="Attach Files"
                            required={false}
                            builtinError={true}
                        />

                        <Header tag="h4" tagStyle="h5">Attach Video (up to 1 video file allowed)</Header>
                        <FormInput
                            type="text"
                            name="video_url"
                            label="URL for Hosted Video"
                            required={false}
                            builtinError={true}
                        />
                    </div>
                </Form>
            </div>
        </>
    );
};
export default RequestServiceForm;
